import { getImageSearchFilters } from 'js/sagas/selectors';
import { useTypedSelector } from 'js/selectors/typedUseSelector';

export default function useSearchFilters() {
  const submittedSearchInput = useTypedSelector(state => state.imageSearch.submittedSearchInput);
  const loading = useTypedSelector(
    state => state.imageDrawer.imageLibrary.search.videoscribe[submittedSearchInput]?.loading
  );
  const { filters } = useTypedSelector(getImageSearchFilters);

  const selectedCount = filters.reduce((acc, filter) => {
    const selected = filter.values.filter(val => val.selected);
    return acc + selected.length;
  }, 0);

  return {
    filters,
    selectedCount,
    loading
  };
}
